"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { ConfettiEffect } from "./ConfettiEffect";

interface CheckoutSuccessContentProps {
  itemCount: number;
}

/**
 * Celebratory hero shared by the /checkout/success route: success image + title
 * + item-count-aware copy + confetti. Pure presentational — no Dialog chrome, no
 * navigation. Ported from the retired CheckoutSuccessModal content.
 */
export const CheckoutSuccessContent = ({
  itemCount,
}: CheckoutSuccessContentProps) => {
  const t = useTranslations("checkout");

  return (
    <div className="text-center text-text-primary">
      <Image
        src="/images/ui/nft-success-purchase.webp"
        alt="success"
        width={128}
        height={128}
        className="mx-auto rotate-[16.99deg] object-cover"
      />
      <h2 className="mt-4 text-lg font-bold">{t("success.title")}</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        {itemCount > 1
          ? t("success.itemsPurchased", { count: itemCount })
          : t("success.itemPurchased")}{" "}
        {t("success.viewDetails")}
      </p>
      <ConfettiEffect />
    </div>
  );
};
